import { render } from "./Statistics.vue?vue&type=template&id=7c3af2aa"
import script from "./Statistics.vue?vue&type=script&lang=ts"
export * from "./Statistics.vue?vue&type=script&lang=ts"
script.render = render

export default script